(() => {
  function init() {
    const root = document.querySelector('.posy-weekly-product');
    if (!root) return;
    function manage() {
      const app = root.querySelector('lb-upsell-product-page-addon.hydrated');
      if (!app || !app.querySelector('input[type="checkbox"]') || app.classList.contains('posy-addons-managed')) return;
      const copy = JSON.parse(root.querySelector('[data-posy-release-copy]').textContent);
      const toggle = document.createElement('button');
      toggle.type = 'button'; toggle.className = 'posy-addons-toggle'; toggle.textContent = copy.addons;
      app.id = 'PosyOptionalAddons'; toggle.setAttribute('aria-controls', app.id); toggle.setAttribute('aria-label', copy.addons);
      toggle.setAttribute('aria-expanded', 'false');
      const summary = document.createElement('p'); summary.className = 'posy-addons-summary'; summary.setAttribute('aria-live', 'polite');
      app.before(toggle, summary);
      app.classList.add('posy-addons-managed', 'posy-addons-hidden');
      function update() {
        const names = [...app.querySelectorAll('input[type="checkbox"]:checked')].map(input => input.closest('.lb-upsell-product-page-card')?.querySelector('.lb-spc-details-name')?.textContent.trim()).filter(Boolean);
        const text = names.length ? copy.selected + ': ' + names.join(', ') : copy.none;
        if (summary.textContent !== text) summary.textContent = text;
      }
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(expanded)); app.classList.toggle('posy-addons-hidden', !expanded);
      });
      app.addEventListener('change', () => requestAnimationFrame(update));
      app.addEventListener('click', () => requestAnimationFrame(update));
      update();
      new MutationObserver(update).observe(app, {childList: true, subtree: true});
      observer.disconnect();
    }
    const observer = new MutationObserver(manage); observer.observe(root, {childList:true,subtree:true}); manage();
    setTimeout(() => observer.disconnect(), 30000);
  }
  function cartCopy() {
    const copy = document.querySelector('[data-posy-cart-production]');
    if (!copy) return;
    const text = JSON.parse(copy.textContent);
    let attempts = 0;
    function attach() {
      const cart = document.querySelector('#upCart')?.shadowRoot;
      if (!cart) return false;
      function align() {
        if (!cart.querySelector('#posy-cart-typography')) {
          const style = document.createElement('style'); style.id = 'posy-cart-typography';
          style.textContent = ':host{font-family:"brandon-grotesque",Arial,sans-serif!important}h1,h2,h3{font-family:"ivypresto-display",Georgia,serif!important;font-weight:700!important;font-style:normal!important;color:#4a4745!important}p,label,input,select,textarea,button{font-family:"brandon-grotesque",Arial,sans-serif!important;font-style:normal!important}p{font-weight:400!important;color:#64615e!important}';
          cart.appendChild(style);
        }
        [...cart.querySelectorAll('p,span,div')].filter(e => e.children.length === 0 && e.textContent.trim() === 'Made to order in Vancouver. Ships in 3-5 days.').forEach(e => { e.textContent = text; });
      }
      align();
      new MutationObserver(align).observe(cart, {childList:true, subtree:true, characterData:true});
      return true;
    }
    if (attach()) return;
    const timer = setInterval(() => { if (attach() || ++attempts >= 120) clearInterval(timer); }, 250);
  }
  function boot() { init(); cartCopy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
